<template>
	<div id="app">
		<v-app id="inspire">
            <v-flex xs12 md12 lg12>
            <v-toolbar flat class="elevation-1" fixed dark color="blue-grey darken-4">
                <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-md-and-up"></v-toolbar-side-icon>
                
                <v-layout>
                    <v-flex class="overflow-hidden">
                        <img onclick="window.location.href = window.location.origin+'/branch-locator';" width="300" height="100" class="pt-1" style="vertical-align:middle" :src="require('../assets/TCM-LOGO-WHITE.png')"/>
                    </v-flex>
                </v-layout>

                <v-spacer></v-spacer>
                <v-menu v-if="user" offset-y class="hidden-sm-and-down">
                    <template v-slot:activator="{ on }">
                        <v-btn dark flat v-if="user" v-on="on" class="hidden-sm-and-down subheading font-weight-medium justify-center">
                            <div v-if="user.fullName">Hi, {{user.fullName}}</div>
                            <div v-else>Hi, {{user.email}}</div>
                            <v-spacer></v-spacer>
                            <v-icon>arrow_drop_down</v-icon>
                        </v-btn>
                    </template>

                    <v-card dark>
                        <v-list class="blue-grey darken-4">
                            <v-list-tile avatar>
                                <v-list-tile-avatar>
                                    <v-avatar v-if="user.photo">
                                        <img :src="user.photo">
                                    </v-avatar>
                                    <v-avatar v-else>
                                        <v-icon size="40">portrait</v-icon>
                                    </v-avatar>
                                </v-list-tile-avatar>
                    
                                <v-list-tile-content>
                                    <v-list-tile-title class="dark">{{user.email}}</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </v-list>
                
                        <v-divider></v-divider>

                        <v-list class="blue-grey darken-4">
                            <v-list-tile onclick="window.location.href = window.location.origin+'/branch-locator';">
                                <v-list-tile-action><v-icon color="green lighten-1">location_on</v-icon></v-list-tile-action>
                                <v-list-tile-content>
                                <v-list-tile-title class="body-2 font-weight-medium">BOOK</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>

                            <v-list-tile @click="(goToPage('transactions'))">
                                <v-list-tile-action><v-icon color="green lighten-1">dashboard</v-icon></v-list-tile-action>
                                <v-list-tile-content>
                                <v-list-tile-title class="body-2 font-weight-medium">TRANSACTIONS</v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                
                            <v-list-tile v-if="email !=''" @click="(goToPage('account'))">
                                <v-list-tile-action class="body-2 font-weight-medium"><v-icon color="green lighten-1">person</v-icon></v-list-tile-action>
                                <v-list-tile-content>
                                <v-list-tile-title class="body-2 font-weight-medium">MY PROFILE</v-list-tile-title> 
                                </v-list-tile-content>
                            </v-list-tile>

                            <v-list-tile v-if="user" class="mt-3" @click="(goToPage('logout'),drawer=false)">
                                <v-list-tile-action>
                                <v-icon color="grey darken-1">exit_to_app</v-icon></v-list-tile-action>
                                <v-list-tile-title class="body-2 font-weight-medium grey--text text--darken-1">LOGOUT</v-list-tile-title>
                            </v-list-tile>
                            
                            <v-list-tile v-else class="mt-3" @click="(goToPage('login'),drawer=false)">
                                <v-list-tile-action>
                                <v-icon color="grey darken-1">exit_to_app</v-icon></v-list-tile-action>
                                <v-list-tile-title class="body-2 font-weight-medium grey--text text--darken-1">LOGIN</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-card>
                </v-menu>

                <v-btn v-else dark flat class="hidden-sm-and-down subheading font-weight-medium justify-center" @click="(goToPage('login'),drawer=false)">
                    <v-spacer></v-spacer>
                    LOGIN
                </v-btn>
			</v-toolbar>

            <v-navigation-drawer :clipped="true" app hide-overlay class="blue-grey darken-4 hidden-md-and-up" v-model="drawer" temporary id="drawer">
                <v-list flat dark>
                    <v-card-title v-if="user" class="subheading font-weight-medium">
                        <div v-if="user.fullName">Hi, {{user.fullName}}</div>
                        <div v-else>Hi, {{user.email}}</div>
                        <v-list-tile-avatar class="justify-center">
                            <img v-if="user.photo" :src="user.photo">
                        </v-list-tile-avatar>
                    </v-card-title>

                    <v-list-tile onclick="window.location.href = window.location.origin+'/branch-locator';">
                        <v-list-tile-action><v-icon color="green lighten-1">location_on</v-icon></v-list-tile-action>
                        <v-list-tile-content>
                        <v-list-tile-title>BOOK</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile @click="(goToPage('transactions'))">
                        <v-list-tile-action><v-icon color="green lighten-1">dashboard</v-icon></v-list-tile-action>
                        <v-list-tile-content>
                        <v-list-tile-title>TRANSACTIONS</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile v-if="email !=''" @click="(goToPage('account'))">
                        <v-list-tile-action><v-icon color="green lighten-1">person</v-icon></v-list-tile-action>
                        <v-list-tile-content>
                        <v-list-tile-title>MY PROFILE</v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>

                    <v-list-tile v-if="user" class="mt-3" @click="(goToPage('logout'),drawer=false)">
                        <v-list-tile-action>
                        <v-icon color="grey darken-1">exit_to_app</v-icon></v-list-tile-action>
                        <v-list-tile-title class="grey--text text--darken-1">LOGOUT</v-list-tile-title>
                    </v-list-tile>
                    
                    <v-list-tile v-else class="mt-3" @click="(goToPage('login'),drawer=false)">
                        <v-list-tile-action>
                        <v-icon color="grey darken-1">exit_to_app</v-icon></v-list-tile-action>
                        <v-list-tile-title class="grey--text text--darken-1">Login</v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-navigation-drawer>
            </v-flex>

            <v-content>
                <v-layout>
                    <v-flex>
                        <router-view :key="$route.fullPath"></router-view>
                    </v-flex>
                </v-layout>
            </v-content>
		</v-app>
	</div>
</template>

<script>
import firebase from "firebase"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { mapGetters, mapActions, mapState } from "vuex"
import { db } from '../main.js'
import _ from 'lodash'
 
export default {
	data: () => ({
        drawer : null,
        updateNotification: false,
        role: "",
        assign: "",
        email: "",
        address: {
            brgy : "",
            city : "",
            state : ""
        },
        mobileNumber: "",
        tin: "",
        firstName: "",
        lastName: "",
        middleName: ""

    }),
 
    methods : {
        goToPage(page) {
            this.$router.push("/"+page)
        },
        
        async getRole() {
            let self = this
            if (self.user) {
                await firebase.auth().onAuthStateChanged(function(user) {
                    db.collection("Users"+self.$stage).doc(user.uid).get().then(function (doc) {
                        self.role = doc.data().role
                        self.firstName = doc.data().firstName
                        self.middleName = doc.data().middleName
                        self.lastName = doc.data().lastName
                        self.tin = doc.data().tin
                        self.mobileNumber = doc.data().mobileNumber
                        self.address = doc.data().address
                        self.assign = doc.data().assign
                        self.email = doc.data().email
                    }).then(function(res) {
                        // if(self.mobileNumber == null || self.mobileNumber == "" && self.firstName == "" && self.lastName == "") {
                        //     self.updateNotification=true
                        // } else {
                        //     self.updateNotification=false
                        // }
                    }).then(function(){
                        // self.fetchMcDetails()
                    }).catch(error => console.log(error))
                })
            }
        },
    },

    mounted() {
        let self = this
        firebase.auth().onAuthStateChanged(function(user) {
            if (user) {
                let googleUser = {
                    uid: user.uid,
                    email: user.email,
                    displayName: user.displayName,
                    photoURL: user.photoURL,
                }

                self.$store.dispatch("setUser", googleUser).then(() => {
                    user.getIdToken().then(function(accessToken) {
                        self.$store.dispatch("setToken", accessToken).then(() => {
                            self.$store.dispatch("setAuth", true).then(() => {
                                db.collection("Users"+self.$stage).doc(user.uid)
                                .onSnapshot(function(doc) {
                                    self.$store.dispatch("setRole", doc.data().role).then(() => {
                                        self.getRole()
                                    }).catch(error => console.log(error))
                                })
                            }).catch(error => console.log(error))	
                        })
                    })
                })
            } 
        })
    },

    watch: {

    },

    computed : {
        ...mapGetters(["user"]),
        ...mapState(["Auth"]),
    }
}

</script>

<style scoped>

#drawer{
    background: rgb(12, 12, 12)
}
</style>